import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import React from 'react'

import { TWhatsappFlowContent } from '@/app/types'

import WhatsappFlowDialog from './whatsapp-flow-dialog'

type Props = {
  content: TWhatsappFlowContent
}

const WhatsappFlow: React.FC<Props> = ({ content }) => {
  const [open, setOpen] = React.useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <Stack spacing={1} alignItems="flex-start">
      {content.message && (
        <Typography color="textPrimary" variant="body2" sx={{ whiteSpace: 'pre-line' }}>
          {content.message}
        </Typography>
      )}
      {content.subtitle && (
        <Typography color="textSecondary" variant="caption" sx={{ whiteSpace: 'pre-line' }}>
          {content.subtitle}
        </Typography>
      )}
      <Button variant="contained" onClick={handleOpen}>
        {content.button}
      </Button>
      <WhatsappFlowDialog content={content} open={open} onClose={handleClose} />
    </Stack>
  )
}

export default WhatsappFlow
